const dev = {
  apiGateway: {
    REGION: 'ap-southeast-1',
    URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  },
  cognito: {
    REGION: 'ap-southeast-1',
    USER_POOL_ID: 'ap-southeast-1_tlhvol4ZD',
    APP_CLIENT_ID: 'fhfun5f2va4smcc9faieqoikv',
  },
}

const prod = {
  apiGateway: {
    REGION: 'ap-southeast-1',
    URL: 'https://lqdb8e5v9d.execute-api.ap-southeast-1.amazonaws.com/prod',
  },
  cognito: {
    REGION: 'ap-southeast-1',
    USER_POOL_ID: 'ap-southeast-1_tlhvol4ZD',
    APP_CLIENT_ID: 'fhfun5f2va4smcc9faieqoikv',
  },
}

const staging = {
  apiGateway: {
    REGION: 'ap-southeast-1',
    URL: 'https://api.cawit.cloud',
  },
  cognito: {
    REGION: 'ap-southeast-1',
    USER_POOL_ID: 'ap-southeast-1_tlhvol4ZD',
    APP_CLIENT_ID: 'fhfun5f2va4smcc9faieqoikv',
  },
}

const test = {
  apiGateway: {
    REGION: 'ap-southeast-1',
    URL: 'https://test-api.cawit.cloud',
  },
  cognito: {
    REGION: 'ap-southeast-1',
    USER_POOL_ID: 'ap-southeast-1_tlhvol4ZD',
    APP_CLIENT_ID: 'fhfun5f2va4smcc9faieqoikv',
  },
}

const stage = process.env.REACT_APP_STAGE
const config =
  stage === 'prod'
    ? prod
    : stage === 'staging'
      ? staging
      : stage === 'test'
        ? test
        : dev

const appConfig = {
  ...config,
}

export default appConfig
